export default "https://a.travel-assets.com/partner-portal/server.fac20cd87f40.svg";